var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.728,
    height: 11.667,
    viewBox: "0 0 6.728 11.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#77757f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3301 -3753.844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.553,13.934,12.1,11.388a.479.479,0,0,1,.679,0,.485.485,0,0,1,0,.681L9.893,14.953a.48.48,0,0,1-.663.014l-2.9-2.9a.481.481,0,0,1,.679-.681Z",
    transform: "translate(3294.813 3750.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.365,2.687,5.909.141a.479.479,0,0,1,.679,0,.485.485,0,0,1,0,.681L3.706,3.707a.48.48,0,0,1-.663.014L.14.824A.481.481,0,0,1,.819.143Z",
    transform: "translate(3307.728 3757.691) rotate(180)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.65354acf6de566c6837137fd031219f1.svg";
export { ForwardRef as ReactComponent };